import {ascend, isNil, isNotNil, sortWith} from 'ramda';

import {SaleVehicleAlbumPhotoGuideItem} from '@dms/api/vehicle';

import {PhotoGuideLayout} from '../types/PhotoGuideLayout';
import {PhotoGuideLayoutItem} from '../types/PhotoGuideLayoutItem';
import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

/**
 * Joins the album's Guide Layout with its photos. A slot whose photo is no longer in the album
 * renders empty and an Extra Photo without its photo is dropped, so a stale layout never shows a
 * tile the album cannot back.
 */
export const buildPhotoGuideLayout = (
  items: SaleVehicleAlbumPhotoGuideItem[],
  albumImages: UnifiedAlbumImage[]
): PhotoGuideLayout => {
  const imagesById = new Map(albumImages.map((image) => [image.id, image]));
  const placedImageIds = new Set<string>();

  const layout = sortWith([ascend((item: SaleVehicleAlbumPhotoGuideItem) => item.position)], items)
    .map((item): PhotoGuideLayoutItem | null => {
      const image = isNotNil(item.saleVehiclePhotoId)
        ? (imagesById.get(item.saleVehiclePhotoId) ?? null)
        : null;
      if (isNotNil(image)) {
        placedImageIds.add(image.id);
      }
      if (isNotNil(item.photoType)) {
        return {kind: 'slot', photoType: item.photoType, required: item.required, image};
      }
      return isNil(image) ? null : {kind: 'extra', image};
    })
    .filter(isNotNil);

  return {
    layout,
    backlog: albumImages.filter((image) => !placedImageIds.has(image.id)),
  };
};
